import { render, staticRenderFns } from "./AllProducts.vue?vue&type=template&id=05e72542&scoped=true&"
import script from "./AllProducts.vue?vue&type=script&lang=js&"
export * from "./AllProducts.vue?vue&type=script&lang=js&"
import style0 from "./AllProducts.vue?vue&type=style&index=0&id=05e72542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e72542",
  null
  
)

export default component.exports